import {
    GET_BULK_ORDER_GRID_COUNT,
    GET_BULK_ORDER_GRID_DATA,
    SET_BULK_ORDER_GRID_COUNT,
    SET_BULK_ORDER_GRID_DATA,
    IS_BULK_ORDER_GRID_LOADING,
    IS_BULK_ORDER_GRID_COUNTS_LOADING
} from "./BulkOrderDashboardType"

const getBulkOrderGridCount = () => ({
    type: GET_BULK_ORDER_GRID_COUNT
});

const setBulkOrderGridCount = (gridCount: any) => ({
    type: SET_BULK_ORDER_GRID_COUNT,
    gridCount
});

const getBulkOrderGridData = (payload: any) => ({
    type: GET_BULK_ORDER_GRID_DATA,
    payload
});

const setBulkOrderGridData = (gridData: any) => ({
    type: SET_BULK_ORDER_GRID_DATA,
    gridData
});

const setIsBulkOrderGridLoading = (flag: any) => ({
    type: IS_BULK_ORDER_GRID_LOADING,
    flag
});

const setIsBulkOrderGridCountsLoading = (flag: any) => ({
    type: IS_BULK_ORDER_GRID_COUNTS_LOADING,
    flag
});

export {
    getBulkOrderGridCount,
    setBulkOrderGridCount,
    getBulkOrderGridData,
    setBulkOrderGridData,
    setIsBulkOrderGridLoading,
    setIsBulkOrderGridCountsLoading
}